import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "../../common/Editor";
import React, {useEffect, useState} from "react";
import Button from "../../common/Button";
import {AppDynamicDropdown} from "../../common/AppDynamicDropdown";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiGetContacts} from "../../api/ApiContacts";
import {apiUpdateSiteContacts} from "../../api/ApiSites";
import useToast from "../../util/useToast";
import styles from "./SiteContactsEditor.module.scss";

const SiteContactsEditor = ({show, onSubmit, hide, site, contacts = []}) => {
  const [formErrors, setFormErrors] = useState({});

  const [formContacts, setFormContacts] = useState([]);

  const {showToastSuccess} = useToast();

  const editMutation = useMutation(apiUpdateSiteContacts(site.id));

  const queryClient = useQueryClient();

  useEffect(() => {
    if (show) {
      if (contacts.length > 0) {
        setFormContacts(contacts.map(contact => ({
          id: contact.id,
          contact: contact.contact,
          type: contact.type,
        })));
      } else {
        setFormContacts([{
          id: null,
          contact: null,
          type: "",
        }]);
      }
    }
  }, [show, contacts]);

  const submit = () => {
    return editMutation.mutateAsync(formContacts)
      .then(() => {
        return (onSubmit ? onSubmit() : Promise.resolve()).then(() => {
          showToastSuccess("Contacts modifiés");
        });
      })
      .then(hide)
      .catch((err) => {
        if (err.response?.status === 400) {
          setFormErrors(err.response.data.errors);
        }
      });
  }

  const updateFormData = (field, contactIndex) => e => {
    const values = {};

    switch (field) {
      case "contact":
        values.contact = e;
        break;
      default:
        values[field] = e.target.value;
        break;
    }

    setFormContacts(prev => {
      prev[contactIndex] = {...prev[contactIndex], ...values};

      return [...prev];
    });
  };

  const addContact = () => setFormContacts(prev => ([...prev, {contact: null, type: ""}]));

  const removeContact = index => () => {
    setFormContacts(prev => {
      const newContacts = [...prev.slice(0, index), ...prev.slice(index + 1)];

      if (newContacts.length === 0) {
        newContacts.push({contact: null, type: ""});
      }

      return newContacts;
    });
  };

  return <Editor
    show={show}
    title={"Modifier les contacts"}
    onSubmit={submit}
    onCancel={hide}
    submitLabel="Sauvegarder"
    cancelLabel="Annuler"
  >
    {formContacts.map((contact, index) => {
      return <div key={contact.contact?.id + "|" + index} className={styles.contactCard}>
        <div className={styles.fields}>
          <Form.Group className="mb-2" controlId={"contact-editor-contact-" + index}>
            <Row>
              <Form.Label column sm={3}>Contact</Form.Label>
              <Col sm={9}>
                <AppDynamicDropdown
                  value={contact.contact}
                  choicesQuery={q => queryClient.fetchQuery(apiGetContacts({filter: q, site: 20, page: 0}))}
                  choiceValue="id"
                  choiceLabel="name"
                  choiceDisplay={choice => <div>{choice.name}</div>}
                  onChange={updateFormData("contact", index)}
                />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group className="mb-0" controlId={"contact-editor-type-" + index}>
            <Row>
              <Form.Label column sm={3}>Type</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  value={contact.type}
                  onChange={updateFormData("type", index)}
                  maxLength="255"
                />
              </Col>
            </Row>
          </Form.Group>
        </div>

        <div className={styles.actions}>
          <Button variant="light" onClick={removeContact(index)} size="sm">
            <span className="material-icons">delete</span>
          </Button>
        </div>
      </div>;
    })}

    <Row className="mt-2">
      <Col sm={3}>&nbsp;</Col>
      <Col sm={9}>
        <Button type="button" variant="primary" onClick={addContact}>Ajouter</Button>
      </Col>
    </Row>
  </Editor>;
};

export default SiteContactsEditor;